var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 2.6875C7.57422 2.71484 7.27344 2.74219 7 2.82422C7.13672 3.04297 7.19141 3.31641 7.21875 3.5625C7.21875 4.41016 6.50781 5.09375 5.6875 5.09375C5.41406 5.09375 5.14062 5.03906 4.94922 4.90234C4.86719 5.17578 4.8125 5.44922 4.8125 5.75C4.8125 7.44531 6.17969 8.8125 7.875 8.8125C9.57031 8.8125 10.9375 7.44531 10.9375 5.75C10.9375 4.08203 9.57031 2.71484 7.875 2.71484V2.6875ZM15.6406 5.36719C14.1641 2.46875 11.2109 0.5 7.875 0.5C4.51172 0.5 1.55859 2.46875 0.0820312 5.36719C0.0273438 5.47656 0 5.61328 0 5.75C0 5.91406 0.0273438 6.05078 0.0820312 6.16016C1.55859 9.05859 4.51172 11 7.875 11C11.2109 11 14.1641 9.05859 15.6406 6.16016C15.6953 6.05078 15.7227 5.91406 15.7227 5.77734C15.7227 5.61328 15.6953 5.47656 15.6406 5.36719ZM7.875 9.6875C5.16797 9.6875 2.67969 8.18359 1.36719 5.75C2.67969 3.31641 5.16797 1.8125 7.875 1.8125C10.5547 1.8125 13.043 3.31641 14.3555 5.75C13.043 8.18359 10.5547 9.6875 7.875 9.6875Z",
    fill: "#9BA1A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon1);
export default __webpack_public_path__ + "static/media/menu-icon-1.7d330e9cd404776a036e52f4dc8e09f3.svg";
export { ForwardRef as ReactComponent };